import { useNextTranslation } from "../../hooks";
import { ProductBookNowButton, ProductBookNowButtonProps } from "../../product/ProductBookNowButton";
import type { ExternalWidgetBokun as ExternalWidgetBokunType } from "../../types/ExternalWidget";

export type ExternalWidgetBokunProps = Omit<ExternalWidgetBokunType, "__typename"> & {
    ButtonComponent?: (props: ProductBookNowButtonProps) => JSX.Element;
};

export function ExternalWidgetBokun({ bookingChannelId, widgetId, ButtonComponent }: ExternalWidgetBokunProps) {
    const Button = ButtonComponent ?? ProductBookNowButton;

    const dataSrc = `https://widgets.bokun.io/online-sales/${bookingChannelId}/experience-calendar/${widgetId}?partialView=1`;
    const [t] = useNextTranslation("externalWidget");
    return (
        <>
            <Button data-src={dataSrc} className="bokunButton">
                {t("bokun.availabilityButton.label")}
            </Button>
        </>
    );
}
